import React, { createRef, useState } from 'react';
import { Icon, } from '../../../../../../../../../index'
import styles from './View/index.module.css';
import './index.css';

import { createFolder } from '../../request';
import { NewFolderIcon, NewFolderIconLarge } from '../../../../../utils/Icon';

const CreateFolder = ({ editor, folderUid, type = 'list', setUploading }) => {
  const [state, setState] = useState({
    folderName: 'New Folder',
    isDisable: true,
  });
  const inputRef: any = createRef();
  const handleEdit = (e) => {
    e.preventDefault();
    if (!state.isDisable) return;
    inputRef.current.focus();
    setState(prevState => ({ ...prevState, isDisable: false, folderName: '' }));
  }

  const handleChange = (e) => {
    e.persist();
    const targetValue = e.target.value
    setState(prevState => ({ ...prevState, [e.target.name]: targetValue }));
  }

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setState(prevState => ({ ...prevState, isDisable: true, folderName: 'New Folder' }))
  }

  const handleOk = (e) => {
    e.preventDefault();
    e.stopPropagation();
    folderUid = folderUid === 'cs_root' ? '' : folderUid;
    setUploading(prevState => ({ ...prevState, uploading: true }));
    createFolder({ ...editor.requestProps, parentUid: folderUid, folderName: state.folderName })
      .then(res => setUploading(prevState => {
        let assets = prevState.assets;
        assets.splice(1, 0, res.asset)
        setState(prevState => ({ ...prevState, isDisable: true, folderName: 'New Folder' }));
        return { ...prevState, assets: assets, uploading: false };
      }))
      .catch(err => { console.error(err) });
  }

  return (

    type === 'list' ? (
      <div data-testid='asset-create-folder-container--list' onClick={handleEdit} className='scrte-asset-create-folder-container'>
        <span className={styles['list-icon']}>
          <NewFolderIcon />
        </span>
        <input data-testid='asset-create-folder--list' ref={inputRef} className='new-folder-input' autoFocus={!state.isDisable} placeholder="Enter folder name" value={state.folderName} onChange={handleChange} name='folderName' />
        {!state.isDisable &&
          (
            <React.Fragment>
              <Icon className='scrte-asset-create-folder__cancel' icon='CancelCircle' onClick={handleCancel} testId="asset-create-folder__cancel--list"></Icon>
              <Icon icon='CheckedCircle' onClick={handleOk} testId="asset-create-folder__confirm--list"></Icon>
            </React.Fragment>
          )}
      </div>
    ) : (
      <div data-testid='asset-create-folder-container--grid' onClick={handleEdit} id='create-folder-grid-card' className={`create-folder-asset-card`}>
        <div className={`flex-v-center flex-h-center create-folder-asset-body`}>
          {state.isDisable ? <NewFolderIconLarge /> :
            (
              <div style={{ textAlign: 'right' }}>
                <Icon testId="asset-create-folder__cancel--grid" size='large' className='scrte-asset-create-folder__cancel' icon='CancelCircle' onClick={handleCancel}></Icon>
                <Icon testId="asset-create-folder__confirm--grid" size='large' icon='CheckedCircle' onClick={handleOk}></Icon>
              </div>
            )}
        </div>
        <div className='create-folder-asset-description'>
          <input data-testid='asset-create-folder--grid' autoComplete='false' ref={inputRef} style={{ 'textAlign': state.isDisable ? 'center' : 'left' }} className={`new-folder-input full-width`} autoFocus={!state.isDisable} placeholder="Enter folder name" value={state.folderName} onChange={handleChange} name='folderName' />
        </div>
      </div>
    )


  )
}


export default CreateFolder;